<script lang="ts" setup>
interface Props {
  isOpened?: boolean
}

interface Emits {
  (event: 'click'): void
  (event: 'search', value: string | undefined): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const clickHandler = () => {
  emit('click')
}

const search = (value?: string) => {
  if (!value) {
    return
  }

  emit('search', value)
  emit('click')
}
</script>

<template>
  <div
    class="search"
    :class="{ 'search--opened': isOpened }"
  >
    <div class="search__form-wrapper">
      <HeaderSearchForm
        :focus="isOpened"
        class="search__form"
        @submit="search"
      />
    </div>
    <UIButton
      variant="clear"
      :appended-icon="isOpened ? 'icon-park-outline:close' : 'tabler:search'"
      is-label-hidden
      class="header__mobile-button"
      @click="clickHandler"
    >
      Open Header Search
    </UIButton>
  </div>
</template>

<style lang="scss" scoped>
.search {
  &__form-wrapper {
    @apply fixed right-0 top-[70px] bg-primary z-[2] w-0 overflow-hidden transition-all duration-300;
    @apply md:right-[50px] md:top-0 md:absolute;
  }

  &--opened &__form-wrapper {
    @apply w-screen;
    @apply md:w-[300px];
  }
}
</style>
